import { Badge, cn } from '@wundo/ui';
import type { ReviewSeverity } from '@/lib/conversationReviews.ts';
import { SEVERITY_LABELS, SEVERITY_MARK_CLASS, SEVERITY_TONES } from './severity.ts';

export interface SeverityPillProps {
  severity: ReviewSeverity | null;
  className?: string;
}

/** How bad this review is, in one word. A review with no verdict reads "Unknown". */
export function SeverityPill({ severity, className }: SeverityPillProps) {
  return (
    <Badge
      tone={severity ? SEVERITY_TONES[severity] : 'quiet'}
      className={cn('gap-1.5', className)}
    >
      <span
        aria-hidden='true'
        className={cn(
          'size-1.5 rounded-full',
          severity ? SEVERITY_MARK_CLASS[severity] : 'bg-ink-muted',
        )}
      />
      {severity ? SEVERITY_LABELS[severity] : 'Unknown'}
    </Badge>
  );
}
